import styled, { keyframes } from 'styled-components'

// Exact Forpy brand colors
export const FORPY_BLUE = '#285FF5'
export const FORPY_BLUE_DARK = '#044DB5'
export const FORPY_ORANGE = '#F79200'

// Animations
export const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(40, 95, 245, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(40, 95, 245, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 95, 245, 0); }
`

export const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
`

// Floating button
export const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${FORPY_ORANGE} 0%, ${FORPY_ORANGE} 100%);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  box-shadow: 0 8px 25px rgba(40, 95, 245, 0.3);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation: ${float} 6s ease-in-out infinite;
  pointer-events: auto;

  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 15px 35px rgba(40, 95, 245, 0.5);
    animation: ${pulse} 2s infinite;
  }

  &:active {
    transform: translateY(0) scale(0.95);
  }

  &.animating {
    animation: none;
  }

  svg {
    width: 24px;
    height: 24px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`
